import { useTranslation } from "react-i18next";
import styles from "./TermsConditions.module.scss";
import SafeHtmlRenderer from "@/components/safeHtmlRenderer/SafeHtmlRenderer";
import EmptyState from "@/components/emptyState/EmptyState";
import bell from "@/assets/img/emptyF2PIcon.png";

type Props = { config: any[] };

const TermsConditions = ({ config }: Props) => {
  const { i18n, t } = useTranslation();

  const currentLangConfig = config.find((item) => item.lang === i18n.language);

  return (
    <div className={styles.titleContainer}>
      <div className={styles.title}>
        <h2>{currentLangConfig?.title ?? t("faqWidget.title")}</h2>
      </div>
      <div className={styles.faqContainer}>
        {currentLangConfig?.faq && currentLangConfig.faq.length > 0 ? (
          <SafeHtmlRenderer htmlContent={currentLangConfig.faq} />
        ) : (
          <EmptyState img={bell} title={t("emptyState.oops")} text={t("emptyState.FAQText")} />
        )}
      </div>
    </div>
  );
};

export default TermsConditions;
